import * as actionTypes from './actionTypes'

export function initializelaceyActValues(payload) {
  return {
    type: actionTypes.INITIALIZE_LACEY_ACT_VALUES,
    payload
  }
}

export function updateActorFeild(headerPartyIndex, field, payload) {
  return {
    type: actionTypes.UPDATE_ACTOR_FIELD,
    payload,
    field,
    headerPartyIndex
  }
}

export function updateActorAddress(headerPartyIndex, field, payload) {
  return {
    type: actionTypes.UPDATE_ACTOR_ADDRESS,
    payload,
    headerPartyIndex,
    field
  }
}

export function addHeaderItemParty(field, payload) {
  return {
    type: actionTypes.ADD_HEADER_ITEM_PARTY,
    payload,
    field
  }
}
export function removeHeaderItemParty(field, payload) {
  return {
    type: actionTypes.REMOVE_HEADER_ITEM_PARTY,
    payload,
    field
  }
}


export function updateHeaderPartyFeild(headerPartyIndex, field, payload) {
  return {
    type: actionTypes.UPDATE_HEADER_PARTY_FIELD,
    payload,
    field,
    headerPartyIndex
  }
}

export function updateHeaderParty(headerPartyIndex, sameAs) {
  return dispatch => {
    dispatch({
      type: actionTypes.UPDATE_HEADER_PARTY,
      headerPartyIndex,
      sameAs
    })
    dispatch(saveHeaderPartiesByHeaderId(headerPartyIndex))
  }
}

export function addHeaderParty() {
  return {
    type: actionTypes.ADD_HEADER_PARTY
  }
}

export function addManufacturer(newManufacturer) {
  return {
    type: actionTypes.ADD_MANUFACTURER,
    newManufacturer
  }
}


export function removeHeaderParty(index) {
  return {
    type: actionTypes.REMOVE_HEADER_PARTY,
    payload: index
  }
}

export function updateHeaderPartyAddress(headerPartyIndex, field, payload) {
  return {
    type: actionTypes.UPDATE_HEADER_PARTY_ADDRESS,
    payload,
    headerPartyIndex,
    field
  }
}

export function updateField(field, payload) {
  return {
    type: actionTypes.UPDATE_FIELD,
    payload,
    field
  }
}

export function updateConsigneeFeild(field, payload) {
  return {
    type: actionTypes.UPDATE_IMPORTER_FIELD,
    payload,
    field
  }
}

export function saveActorName(actor) {
  return {
    type: actionTypes.SAVE_ACTOR_NAME,
    actor
  }
}

export function saveActorAddress(actor) {
  return {
    type: actionTypes.SAVE_ACTOR_ADDRESS,
    actor
  }
}

export function saveHeaderParties(index) {
  return {
    type: actionTypes.SAVE_HEADER_PARTIES,
    index
  }
}

export function saveHeaderPartiesByHeaderId(headerId) {
  return {
    type: actionTypes.SAVE_HEADER_PARTIES_BY_HEADER_ID,
    headerId
  }
}

export function saveImporter() {
  return {
    type: actionTypes.SAVE_IMPORTER
  }
}

export function saveConsignee() {
  return {
    type: actionTypes.SAVE_CONSIGNEE
  }
}
